export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: datalayerObject) => void
  }
}

export type datalayerObject = {
  event?: string
  category: string
  action: string
  label?: string
}

export const acceptCookiesDatalayer = (cookies: string, path: string) =>
  pushRefrescoDatalayer({
    category: 'Cookies',
    action: cookies,
    label: path
  })

export const acceptAllCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Accept all', path)

export const acceptVideoCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Video', path)

export const acceptTrackingCookiesDatalayer = (path: string) => acceptCookiesDatalayer('Tracking', path)

export const switchLanguageDatalayer = (language: string, path: string) =>
  pushRefrescoDatalayer({
    category: 'language',
    action: language,
    label: path
  })

export const contactButtonDatalayer = (path: string) =>
  pushRefrescoDatalayer({
    category: 'Contact - Header',
    action: 'Click button',
    label: path
  })

export const contactFormDatalayer = (subject: string) =>
  pushRefrescoDatalayer({
    category: 'Contact',
    action: 'Form',
    label: subject
  })

export const headerSearchBarFormDatalayer = (res: 'result' | 'no_result', searchTerm: string) =>
  pushRefrescoDatalayer({
    category: 'vacancy_search',
    action: res,
    label: searchTerm
  })

export const vacancyFooterButtonFormDatalayer = (buttonText: string) =>
  pushRefrescoDatalayer({
    category: 'vacancy_footer_button',
    action: buttonText,
    label: window.location.pathname
  })

export const vacancyFormFormDatalayer = (res: 'start_application' | 'submit_application') =>
  pushRefrescoDatalayer({
    category: 'vacancies',
    action: res,
    label: window.location.pathname
  })

export const languageSwitchFormDatalayer = (linkTitle: string) =>
  pushRefrescoDatalayer({
    category: 'language',
    action: linkTitle,
    label: window.location.pathname
  })

export const vacancyHeaderButtonFormDatalayer = (buttonText: string) =>
  pushRefrescoDatalayer({
    category: 'vacancy_header_button',
    action: buttonText,
    label: window.location.pathname
  })

export const pushRefrescoDatalayer = (data: { category: string; action: string; label: string }) =>
  pushDatalayer({ ...data, event: 'event.refresco' })

export const pushDatalayer = (d: datalayerObject) => {
  const defaultParams = {
    event: 'event.refresco',
    label: window.location.pathname
  }

  const params = { ...defaultParams, ...d }

  window.dataLayer ? window.dataLayer.push(params) : console.log(params)
}
